import React from 'react';
import desk from '../../../assets/qrcode/desk.png';
import { 
  Card, 
  CardBody,
} from 'reactstrap';

export const TableCard = ({ table, onClick }) => {
    const occupiedStyle = table.isOccupied ? 'rgba(220, 53, 69, 0.5)' : 'rgba(25, 135, 84, 0.7)';
    
    return (
        <Card 
            className="mb-4 shadow-sm position-relative" 
            onClick={onClick}
            style={{ cursor: table.isOccupied ? 'pointer' : 'default' }}
        >
            <div className="position-relative">
                <div className="position-relative">
                    <img 
                        src={desk} 
                        className="card-img-top w-100 object-fit-cover" 
                        alt="Table"
                    />
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            background: occupiedStyle,
                            transition: 'background-color 0.3s ease'
                        }}
                    />
                    <div className="position-absolute top-0 start-0 w-100 h-100 p-3 text-white">
                        <div className="d-flex justify-content-between">
                            <div>
                                <h5 className="fw-bold text-white mb-1">{table.identification}</h5>
                                <p className="mb-0 text-white-75">{table.description}</p>
                            </div>
                            <span className="text-white">ID: {table.id}</span>
                        </div>
                        <div className="position-absolute bottom-0 start-0 p-3">
                            <span className="badge bg-white text-dark">
                                {table.isOccupied ? 'Occupied' : 'Available'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <CardBody className="p-3 bg-light">
                <div className="d-flex justify-content-between align-items-center">
                    <span className={`badge ${table.isActive ? 'bg-success' : 'bg-secondary'}`}>
                        {table.isActive ? 'Active' : 'Inactive'}
                    </span>
                    <small className="text-muted">
                        {table.isOccupied ? 'Click to view order' : 'Ready for Service'}
                    </small>
                </div>
            </CardBody>
        </Card>
    );
};